var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditLineSmall = function SvgEditLineSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EditLineSmall_svg__Edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "EditLineSmall_svg__Vector",
    d: "M2.49995 9.33582H4.32662L9.12164 4.5408C9.24158 4.42086 9.33672 4.27847 9.40163 4.12176C9.46654 3.96505 9.49995 3.79709 9.49995 3.62747C9.49995 3.45785 9.46654 3.28988 9.40163 3.13317C9.33672 2.97646 9.24158 2.83407 9.12164 2.71413C9.0017 2.59419 8.85931 2.49905 8.7026 2.43414C8.54588 2.36923 8.37792 2.33582 8.2083 2.33582C8.03868 2.33582 7.87072 2.36923 7.71401 2.43414C7.5573 2.49905 7.41491 2.59419 7.29497 2.71413L2.49995 7.50914V9.33582Z",
    stroke: "currentColor",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EditLineSmall_svg__Vector_2",
    d: "M6.75 3.25L8.25 4.75",
    stroke: "currentColor",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgEditLineSmall;